import { defineStore } from 'pinia'
import apiAccount from '@/api/account'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { useStaffStore } from '@/stores/modules/staff'
import { useOrderStore } from '@/stores/modules/order'
// import { useMerchantStore } from '@/stores/modules/merchant'

export const useUserStore = defineStore('user', {
  state: () => ({
    token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    rolePermission: null, // 员工权限
    staffName: '' // 员工姓名
  }),
  getters: {
    dataPermissions: (state) => {
      return state.rolePermission?.data_permissions
    }
  },
  actions: {
    /**
     * 用户登录(因为是扫码登录，所以直接将登录成功的 token 传过来初始化就行)
     */
    login(userInfo) {
      const { token } = userInfo
      this.token = token
      setToken(token)
    },

    /**
     * 获取用户当前信息
     */
    async getInfo() {
      const { data } = await apiAccount.getInfo()
      const { roles, username, avatar, intro, rolePermission, staff_name } = data
      this.rolePermission = rolePermission
      this.roles = roles
      this.name = username
      this.avatar = avatar
      this.introduction = intro
      this.staffName = staff_name

      return {
        username: username,
        avatar: avatar,
        introduction: intro,
        roles: roles,
        rolePermission
      }
    },

    /**
     * 退出登录
     */
    logout() {
      // 清空token
      this.resetToken()

      // 清空员工信息
      const staffStore = useStaffStore()
      staffStore.clearStaffInfo()
      // 清空台位商品缓存
      const orderStore = useOrderStore()
      orderStore.clearDeskPackageProductList()

      // 没必要清空商户信息，点单机一般不切换商家
      // const merchantStore = useMerchantStore()
      // merchantStore.clearMerchantInfo()
    },

    // remove token
    resetToken() {
      removeToken()

      // 重置store
      this.$reset()
    }
  }
})
